// firebaseConfig.js

import { initializeApp } from "firebase/app";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject
} from "firebase/storage";

import {
  getFirestore,
  collection,
  addDoc,
  setDoc,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  deleteDoc,
  updateDoc,
  writeBatch,
  orderBy,
  limit,
  startAt,
  onSnapshot,
  arrayRemove,
  arrayUnion,
  serverTimestamp
} from "firebase/firestore";

import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";

// ===============================
// KONFIGURASI FIREBASE
// ===============================

const firebaseConfig = {
  apiKey: "AIzaSyAiWycK0hIpzVy5w-gCdK2tfpQY9VVdWEc",
  authDomain: "hsprojectschool.firebaseapp.com",
  projectId: "hsprojectschool",
  storageBucket: "hsprojectschool.appspot.com",
  messagingSenderId: "1091596013315",
  appId: "1:1091596013315:web:c6011a35b82547ab75a336",
  measurementId: "G-SPBN3DPXVJ",
};

// ===============================
// INISIALISASI
// ===============================

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// ===============================
// UPLOAD HELPER (Reusable)
// ===============================

export const uploadImageWithProgress = (
  file,
  userId,
  folder = "img",
  onProgress,
  onComplete,
  onError
) => {
  if (!file || !userId) return;

  const fileName = `${Date.now()}_${file.name}`;
  const storageRef = ref(storage, `${userId}/${folder}/${fileName}`);
  const uploadTask = uploadBytesResumable(storageRef, file);

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const progress =
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

      if (onProgress) onProgress(progress);
    },
    (error) => {
      if (onError) onError(error);
    },
    async () => {
      const downloadURL = await getDownloadURL(
        uploadTask.snapshot.ref
      );

      if (onComplete) onComplete(downloadURL);
    }
  );

  return uploadTask;
};

// ===============================
// EXPORT
// ===============================

export {
  db,
  storage,
  auth,
  ref,
  deleteObject,
  collection,
  addDoc,
  setDoc,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  deleteDoc,
  updateDoc,
  writeBatch,
  startAt,
  orderBy,
  limit,
  onSnapshot,
  arrayRemove,
  arrayUnion,
  serverTimestamp,
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  uploadBytesResumable,
  getDownloadURL
};
